import Analytics from '@jetshop/core/analytics/Analytics';
import { trackListEvent } from '@jetshop/core/analytics/tracking';
import GridProduct from '@jetshop/ui/ProductList/GridProduct';
import React, { Fragment } from 'react';
import { styled } from 'linaria/react';
const ProductGridContainer = /*#__PURE__*/styled('div')({
  name: "ProductGridContainer",
  class: "ps6s3qa"
});
const productPlaceholder = {
  name: '',
  id: 'placeholder',
  images: []
};

const ProductGrid = ({
  className = '',
  products,
  loading,
  listName,
  categoryPath = null,
  category = '',
  search,
  hash,
  ProductComponent = GridProduct
}) => {
  const productList = products.length === 0 && loading ? Array(4).fill(productPlaceholder) : products;
  return React.createElement(ProductGridContainer, {
    "data-testid": "product-grid",
    className: className
  }, products && React.createElement(Fragment, null, !loading ? React.createElement(Analytics, {
    event: trackListEvent({
      listName,
      products: products,
      category
    })
  }) : null, productList.map((product, index) => React.createElement(ProductComponent, {
    listName: listName,
    search: search,
    hash: hash,
    loading: loading,
    key: `${index}${product.id}`,
    product: product,
    categoryPath: categoryPath
  }))));
};

export default ProductGrid;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/ProductList/ProductGrid.linaria.css");